import { createImgSrcset } from '@/scripts/utils';
import cart from '@cell/cell-core/cart';
import Component from '@cell/cell-core/component/component';
import './upsell-card.scss';

class UpsellCard extends Component {
  constructor() {
    super();

    this.product = {
      title: this.parsedDataset.productTitle,
      vendor: this.parsedDataset.productVendor,
      type: this.parsedDataset.productType,
    };

    // The selected variant is set once the all the available variants are fetched from the wrapping
    // `product-context`.
    // Initialize as `null` and call the method to set it.
    this.selectedVariant = null;
    this.setSelectedVariant();

    this.handleAddToCartClick = this.handleAddToCartClick.bind(this);
    this.handleAddToCart = this.handleAddToCart.bind(this);
    this.handleVariantSelectorChange = this.handleVariantSelectorChange.bind(this);
  }

  componentDidMount() {
    this.on('c-button.click.add-to-cart', this.handleAddToCartClick);
    this.on('product-variant-selector.change', this.handleVariantSelectorChange);
  }

  async setSelectedVariant() {
    const variants = await this.productContextElement.get('product.variants');

    const selectedVariant = variants.find(
      (variant) => variant.id === this.querySelector('product-variant-selector').selectedVariant.id,
    );

    this.selectedVariant = selectedVariant;
  }

  handleAddToCartClick() {
    this.handleAddToCart();
  }

  async handleAddToCart() {
    // Show button loading state.
    this.addToCartButtonElement.setLoading(true);

    const quantity = 1;

    const { data, errors } = await cart.addItem({
      id: this.productVariantSelectorElement.selectedVariant.id,
      quantity,
    });

    if (errors.length > 0) {
      // TODO: Handle max quantity error.

      return;
    }

    this.emit('add-to-cart', {
      section: data.sections['cart-drawer'],
      quantity,
    });
  }

  handleVariantSelectorChange(event) {
    // Note: Currently this component expects the prices of all variants to be the same. If this is
    // not the case, you will need to update the code below to handle price changes.

    const { selectedVariant } = event.data;

    // Instead of updating the selected variant directly, we need to fetch the updated variant
    // from the product context since the selected variant received from the
    // `product-variant-selector` doesn't contain all the necessary information we need.
    this.setSelectedVariant();

    // Update the image.

    const newImgSrc = selectedVariant.featured_image.src;
    const newImgAlt = selectedVariant.featured_image.alt;

    const newImgSrcSet = createImgSrcset(
      selectedVariant.featured_image.src,
      [165, 360, 533, 720, 940, 1066, 1500],
    );

    this.imageElement.setAttribute('src', newImgSrc);
    this.imageElement.setAttribute('srcset', newImgSrcSet);
    this.imageElement.setAttribute('alt', newImgAlt);
  }

  get productContextElement() {
    return this.closest('product-context');
  }

  get productVariantSelectorElement() {
    return this.querySelector('product-variant-selector');
  }

  get imageElement() {
    return this.querySelector('.UpsellCard__Image img');
  }

  get addToCartButtonElement() {
    return this.querySelector('[data-action="add-to-cart"]');
  }
}

customElements.define('upsell-card', UpsellCard);
